/* tslint:disable */
/* eslint-disable */
/**
 * Bias Proof License API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourseConfigurationDTO
 */
export interface CourseConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof CourseConfigurationDTO
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseConfigurationDTO
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CourseConfigurationDTO
     */
    courseModuleIds?: Array<string>;
}

export function CourseConfigurationDTOFromJSON(json: any): CourseConfigurationDTO {
    return CourseConfigurationDTOFromJSONTyped(json, false);
}

export function CourseConfigurationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourseConfigurationDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'courseModuleIds': !exists(json, 'courseModuleIds') ? undefined : json['courseModuleIds'],
    };
}

export function CourseConfigurationDTOToJSON(value?: CourseConfigurationDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryId': value.categoryId,
        'id': value.id,
        'courseModuleIds': value.courseModuleIds,
    };
}


